const CaptionText = {
  fontFamily: "Mukta Vaani",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  fill: "hsla(213, 100%, 12%, 0.6)"
};

const GraphText = {
  fontFamily: "Roboto",
  fontSize: "11px",
  fontWeight: "500",
  lineHeight: "13px",
  letterSpacing: "1px",
  fill: "hsla(213, 100%, 12%, 0.94)"
};

export { CaptionText, GraphText };



// WEBPACK FOOTER //
// ./src/components/dashboard/styles.js